const riot = require('riot');

riot.tag2('page-webhooks', '<div class="s-full f"> <div class="flex-fixed" data-is="module-sidebar"></div> <div class="h-full w0 flex-auto f fclm bg-pale_gray"> <div class="flex-fixed bg-white" data-is="module-page-header" project="{project}" title="Webhookテンプレート管理"> <yield to="right"> <button class="button primary" if="{app.utils.permission.has(&quot;project_writer&quot;, { company_id: parent.companyId, project_id: parent.projectId })}" onclick="{parent.onGoWebhook}">Webhookテンプレート新規作成</button> </yield> </div> <div class="f fclm h0 flex-auto w-full py36 px40"> <div class="f fclm flex-height-auto w-full overflow-hidden rounded-8 bg-white elevation-default-low"> <div class="flex-height-auto w-full" data-is="module-table" schemas="{tableSchemas}" items="{projectWebhookSettings}" scroll-type="y"></div> <div class="flex-fixed f fr px28"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div> </div>', 'page-webhooks,[data-is="page-webhooks"]{display:block}', '', function(opts) {
    this.limit = 50;

    this.tableSchemas = [
      {
        id: 'name',
        label: '名前',
        component: 'link',
        getLink: (item) => `${location.pathname}/${item.id}`,
      },
      {
        id: 'webhook_endpoint',
        label: 'URL',
      },
      {
        id: 'http_method',
        label: 'メソッド',
      },
      {
        id: 'menu',
        component: 'material-icon-button',
        align: 'center',
        class: 'flex-fixed w48',
        text: 'more_vert',
        onclick: (item, e) => {
          this.onOpenActionSheet(item, e);
        },
        shouldShow: () => {
          return app.utils.permission.has('project_writer', { company_id: this.companyId, project_id: this.projectId });
        }
      },
    ];

    this.preload = async ({req, res}) => {
      var company_id = req.params.company_id;
      var project_id = req.params.project_id;
      var api = app.api.child(`companies/${company_id}/projects/${project_id}/project_webhook_settings`);
      var { project_webhook_settings, pagination } = await api.get({ offset: 0, limit: this.limit });

      return {
        projectWebhookSettings: project_webhook_settings,
        api,
        pagination,
        companyId: company_id,
        projectId: project_id,
      };
    };

    this.on('mount', () => {

      this.refs.pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = this.pagination[offset_type];
        var query = {
          offset,
          limit: this.limit,
        };

        try {
          var { project_webhook_settings, pagination } = await this.api.get(query);
          this.projectWebhookSettings = project_webhook_settings;
          this.pagination = pagination;
          this.update();
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      });

    })

    this.onGoWebhook = () => {
      spat.router.push(`${location.pathname}/new`);
    };

    this.onOpenActionSheet = (item, e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "trash",
          label: "削除",
          action: () => { popup.close(); this.deleteWebhook(item); },
          alert: true
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        align: {x: 'right'},
        position: 'bottom',
        opts: {
          options,
        }
      });
    };

    this.deleteWebhook = async (webhook) => {
      var result = await app.utils.openModalDialog(
        {
          title: 'Webhookの削除',
          text: '本当にこのWebhookを削除しますか？今後このWebhookを利用した送信は行うことができなくなります。この操作は取り消すことができません。',
          size: 'medium',
          danger: true,
          positive: '削除',
        }
      );
      if (!result) return;

      var indicator = spat.modal.indicator();
      try {

        await this.api.child(webhook.id).del({});

        var { project_webhook_settings, pagination } = await this.api.get({ offset: 0, limit: this.limit });
        this.projectWebhookSettings = project_webhook_settings;
        this.pagination = pagination;
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };
});